import { FC } from 'react';

import PageLayout from 'src/pages/Profession/ProfessionPageLayout';

const ProfessionPage: FC = () => <PageLayout />;

export default ProfessionPage;
